export interface Volume {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Motion Makers',
    description: 'Build things that roll, spin, launch, balance, and move.',
    tag: '24 builds · Easy → Challenge',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/f759TGcrBYr4mLuZk6SGyz/young-inventor-lab-volume-01-motion-makers.webp',
  },
  {
    number: '02',
    title: 'Cardboard Engineers',
    description:
      'Turn boxes and recycled materials into clever structures and simple machines.',
    tag: '24 builds · Easy → Challenge',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3izzzjTZbg9RnfM8wR5CEi/young-inventor-lab-volume-02-cardboard-engineers.webp',
  },
  {
    number: '03',
    title: 'Power & Simple Circuits',
    description: 'Explore energy and simple circuits through hands-on discovery.',
    tag: '24 builds · Easy → Challenge',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/j1aJNSgA3RNEN7rgmduJEK/young-inventor-lab-volume-03-power-simple-circuits.webp',
  },
  {
    number: '04',
    title: 'Science in Action',
    description:
      'Test, observe, and uncover the science behind everyday forces and reactions.',
    tag: '24 builds · Easy → Challenge',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3qLMRPjgSBEZNFkLWqtKjs/young-inventor-lab-volume-04-science-in-action.webp',
  },
  {
    number: '05',
    title: 'Big Idea Challenges',
    description:
      'Open-ended invention challenges that invite kids to plan, test, improve, and create.',
    tag: '24 builds · Easy → Challenge',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/54mWdoZqkgQQ7c72aofmWR/young-inventor-lab-volume-05-big-idea-challenges.webp',
  },
];

export interface BuildCard {
  title: string;
  src: string;
  alt: string;
}

export const buildCards: BuildCard[] = [
  {
    title: 'Balloon-Powered Race Car',
    src: 'https://cdn.magicpatterns.com/uploads/a2tTfsM27k7pjC2M39Dxn5/01-balloon-powered-race-car.webp',
    alt: 'Build card for the Balloon-Powered Race Car',
  },
  {
    title: 'Cardboard Bridge',
    src: 'https://cdn.magicpatterns.com/uploads/9NZKeV65jo1ZFu5ty4dKvf/02-cardboard-bridge-real-build.webp',
    alt: 'Build card for the Cardboard Bridge, shown next to the finished build',
  },
  {
    title: 'Charge Detector',
    src: 'https://cdn.magicpatterns.com/uploads/4D8TQS53U4G329XtL7SKQS/03-charge-detector.webp',
    alt: 'Build card for the Charge Detector',
  },
  {
    title: 'Color-Changing Lab',
    src: 'https://cdn.magicpatterns.com/uploads/mUtZm4mFx3rG8dBb2AWoQe/04-colour-changing-lab.webp',
    alt: 'Build card for the Color-Changing Lab',
  },
  {
    title: 'Chain Reaction Machine',
    src: 'https://cdn.magicpatterns.com/uploads/wjvnf8Kjsg65irkJBUDsMn/05-chain-reaction-machine.webp',
    alt: 'Build card for the Chain Reaction Machine',
  },
  {
    title: 'Popsicle Stick Catapult',
    src: 'https://cdn.magicpatterns.com/uploads/2t1nnQw6ikVbqKgncSXZCs/06-popsicle-stick-catapult.webp',
    alt: 'Build card for the Popsicle Stick Catapult',
  },
  {
    title: 'Crane With Counterweight',
    src: 'https://cdn.magicpatterns.com/uploads/dULiG8cVnfvEWdkdqu3d7s/07-crane-with-counterweight.webp',
    alt: 'Build card for the Crane With Counterweight',
  },
  {
    title: 'Working Traffic Light',
    src: 'https://cdn.magicpatterns.com/uploads/85cTo4BvEaipxGvQzEbKPm/08-working-traffic-light_(1).webp',
    alt: 'Build card for the Working Traffic Light',
  },
];

export interface Bonus {
  badge: string;
  title: string;
  description: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    title: 'The 7-Day Maker Kickstart',
    description:
      'Seven ready-to-go days of hands-on making, so you can start right away.',
  },
  {
    badge: 'BONUS 2',
    title: 'The Materials Swap Guide',
    description:
      'Smart alternatives for those moments when you do not have the exact supply.',
  },
  {
    badge: 'BONUS 3',
    title: 'Build Fix-It Cards',
    description:
      'Quick troubleshooting prompts that turn a setback into the next great idea.',
  },
  {
    badge: 'BONUS 4',
    title: 'Backyard Maker Missions',
    description: '12 outdoor invention missions plus a printable maker log.',
  },
  {
    badge: 'BONUS 5',
    title: '52 Weeks of Wonder',
    description: '52 weekly STEM prompts plus a printable 52-week wonder poster.',
  },
];

export interface ProofPoint {
  title: string;
  description: string;
}

export const proofPoints: ProofPoint[] = [
  {
    title: 'Clear from the start',
    description:
      'Age, time, difficulty, and adult-help level are visible before you begin.',
  },
  {
    title: 'Built for real homes',
    description:
      'Every project starts with materials families can recognize and find.',
  },
  {
    title: 'A real result',
    description:
      'Kids make something that moves, spins, launches, balances, or solves a challenge.',
  },
  {
    title: 'Room to grow',
    description:
      'Easy → Guided → Challenge helps confidence build alongside curiosity.',
  },
  {
    title: 'More than a screen-time replacement',
    description:
      'Each project invites kids to imagine, test, improve, and try again.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'What exactly do I receive?',
    answer:
      'You receive instant digital access to all five printable volumes, 120 visual build cards, the Build Path Guide, the Inventor Progress Tracker, and all five maker bonuses.',
  },
  {
    question: 'Is this a physical STEM kit?',
    answer:
      'No. The Young Inventor Lab™ is a digital printable library. No physical kit or materials are shipped.',
  },
  {
    question: 'What ages is it designed for?',
    answer:
      'It is designed for curious kids ages 5–12. Every card includes a suggested age, build time, difficulty level, and adult-help indicator.',
  },
  {
    question: 'What materials will we need?',
    answer:
      'Each build uses a short list of familiar household or recycled materials. You can see the list before starting, and the Materials Swap Guide helps when a supply is missing.',
  },
  {
    question: 'How does the challenge progression work?',
    answer:
      'The library moves from Easy to Guided to Challenge, so kids can build confidence and take on bigger ideas over time.',
  },
  {
    question: 'Will I need to guide every build?',
    answer:
      'Every card clearly shows whether adult help is recommended. Some children will build independently, while others will enjoy making alongside an adult.',
  },
  {
    question: 'Can I use it for homeschool or a classroom?',
    answer:
      'Yes. The format works beautifully for home, homeschool, tutoring, and small-group learning. Please follow the license terms included with your purchase.',
  },
  {
    question: 'Is this a subscription?',
    answer: 'No. It is a one-time payment of $27 USD.',
  },
  {
    question: 'How do I access the files?',
    answer: 'Your digital access appears immediately after checkout.',
  },
  {
    question: 'Are the builds safe?',
    answer:
      'Every card includes a safety note. Follow it carefully and use adult supervision whenever it is indicated.',
  },
];
